var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('row-stat-display',{attrs:{"title":`${_vm.title}`,"name-first-column":'Libelle',"name-second-column":'Valeur',"datas":_vm.datas}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }